<template>
  <div>
    <div class="litops orangeToYellow" :style="{ height: '60px', textAlign:'center', color:'#ffffff', lineHeight:'60px', fontSize: '20px', fontWeight: 500 }">
      绑定传感器
    </div>
    <div class="rform">
      <van-form @submit="()=>handleSubmit()">
        <div>
          <!-- RTU id -->
          <div class="scan">
            <van-field v-model="rtuID" @input="e=> rtuInputDebunce(e)" aria-autocomplete="off" autocomplete="off" maxlength="8" name="rtuID" label="传感器 ID" placeholder="传感器 ID">
              <template #button>
                <van-button class="scan_code" @click.stop="handleScanCode">
                  <img width="20" height="20" src="./../../../assets/images/scancode.png" />
                </van-button>
              </template>
            </van-field>
          </div>
          <!-- RTU密码 -->
          <van-field name="pwd" v-model="cgqName" type="text" label="传感器名称" placeholder="" disabled />
          <!-- 网关 id -->
          <van-field name="wgID" v-model="wgID" label="所属网关" placeholder="网关ID" disabled />
        </div>
        <!-- 提交 -->
        <div class="btns">
          <van-button class="btn cancelBtn" @click="handleCancel">取消</van-button>
          <van-button class="btn confirmBtn" native-type="submit">确定</van-button>
          <van-button class="btn confirmBtn" @click.native.prevent="handleUnBind">解绑传感器</van-button>
        </div>
      </van-form>

      <div>
        <div :style="{ fontSize: '16px', margin: '10px 0' }">已绑定的传感器:</div>
        <div :style="{ fontSize: '14px' }">
          <div class="cgqItem" v-for="item in cgqList" :key="item.name" :style="{ marginBottom: '4px' }">
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import config from '@/utils/config'
import { Dialog } from 'vant';

export default {
  data () {

    let valveRtuRelationList = sessionStorage.getItem("valveRtuRelationList")
    if (valveRtuRelationList) {
      valveRtuRelationList = JSON.parse(valveRtuRelationList)
    } else {
      valveRtuRelationList = []
    }
    const deviceType = sessionStorage.getItem("deviceType")
    return {
      radio: '1',
      rtuID: '',
      wgID: '',
      cgqName: '',
      isTxt: false,
      showTabs: false,
      ishow: false,
      port1: "",
      port2: "",
      defaultIndex: 0,
      popTit: "端口1",
      pickerIndex: 1,
      href: '',
      valveRtuRelationList,
      deviceType,
      canUSe: false,
      alreadyBindIds: [],
      cgqList: []
    }
  },

  async created () {
    const query = this.$route.query
    if (query.wgId) {
      this.wgID = query.wgId
      this.radio = '2'
    }
    this.rtuInputDebunce = this.$debounce(this.getPortAndValae, 500)
    this.href = window.location.href

    if (this.wgID) {
      this.getCgqList()
    }
  },

  methods: {
    async getCgqList () {
      await this.$api.getLiveList20({
        no: this.wgID,
        limit: 1,
        startDate: '2020-01-01 00:00:00',
        endDate: this.$setime(new Date(), 1),
      }).then(res => {
        if (res.errcode === 0) {
          if (!this.$isblank(res.list)) {
            const list = res.list
            const arr = []
            list.map(item => {
              arr.push(item.id)
            })
            this.cgqList = [...list]
            this.alreadyBindIds = [...arr]
          }
        }
      })
    },
    getPortAndValae (val) {
      if (val && String(val.trim()).length > 0) {
        this.$api.getGatewaySensor(String(val.trim())).then(res => {
          if (res.errcode === 0) {
            if (res.data?.name) {
              this.cgqName = res.data?.name
              this.canUSe = true
            } else {
              // 传感器没有具体信息，要么是不存在，要么是已经绑定
              const find = this.cgqList.find(o => o.id == Number(val.trim()))
              if (find) {
                this.cgqName = find?.name + '-已绑定'
                this.canUSe = false
                this.$toast('传感器已经绑定')
              } else {
                this.cgqName = ''
                this.canUSe = false
                this.$toast('传感器不存在')
              }
            }
          } else {
            this.cgqName = ''
            this.canUSe = false
            this.$toast(res.errmsg)
          }
        })
      }
    },

    wxConfig () {
      const that = this
      this.$api
        .getWxConfig({
          appid: config.getAppId(),
          url: window.location.href,
        })
        .then(async (res) => {
          if (res.errcode === 0) {
            const {
              sign: { timestamp, noncestr, signature },
            } = res

            window.wx.config({
              timestamp: Number(timestamp),
              nonceStr: noncestr,
              signature,
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: config.getAppId(), // 必填，公众号的唯一标识
              jsApiList: ['scanQRCode'], // 必填，需要使用的JS接口列表
            })

            window.wx.ready(function () {
              // alert("readyready")
              window.wx.checkJsApi({
                jsApiList: ['scanQRCode'],
                success: function (res) {
                  // alert("ready22:", typeof res === "string" ? res : JSON.stringify(res))
                  if (res.checkResult.scanQRCode) {
                    that.scan()
                  }
                },
              })
            })
          } else {
            this.$toast({
              type: 'fail',
              message: res.errmsg || this.$t('bind.msg_error_wg'),
            })
          }
        })
    },

    // 扫码
    async handleScanCode (e) {
      e.preventDefault()
      e.stopPropagation()
      //   获取wx的相关api配置
      await this.wxConfig()
    },

    scan () {
      const that = this
      this.$wx.scanQRCode({
        needResult: 1, // 当needResult 为 1 时，扫码返回的结果
        scanType: ['qrCode', 'barCode'],
        success: function (res) {
          setTimeout(() => {
            const result = res.resultStr
            const info = result.split('|')
            if (that.radio === '1') {
              that.wgID = info[0]
            } else {
              that.rtuID = info[0]
              that.getPortAndValae(info[0])
            }

            that.pwd = info[1]
          }, 200)
        },
        fail: function (res) {
          console.error("res:", res);
          that.$toast(
            '扫码失败:',
            typeof res === 'string' ? res : JSON.stringify(res),
          )
        },
      })
    },

    // 重置
    resetState () {
      const wgID = this.wgID
      Object.assign(this.$data, this.$options.data());
      this.wgID = wgID
    },

    handleCancel () {
      this.$router.back()
    },

    // 解绑RTU设备
    async handleUnBind () {
      if (!this.rtuID) return this.$toast("RTU编号不能为空")
      Dialog({
        title: '解绑传感器',
        message: '确定解绑传感器吗？',
        showCancelButton: true
      })
        .then(async () => {
          const arr = [...this.alreadyBindIds]
          const findIndex = this.alreadyBindIds.findIndex(o => o == Number(this.rtuID))
          arr.splice(findIndex, 1)
          this.handleSubmit(arr)
        })
        .catch(() => {
        });
    },

    // 激活
    async handleSubmit (sensorIds) {
      await this.$toast.loading({
        message: this.$t('common.loading'),
        forbidClick: true,
        duration: 0,
      })
      // 校验不能为空
      const { pwd, rtuID, wgID, radio } = this
      //   网关
      if (!wgID.trim()) return this.$toast(this.$t('bind.msg_wgID'))
      //   绑定网关

      try {
        if (!this.canUSe && !sensorIds) return this.$toast(`传感器不存在或已经绑定，请确认`)
        await this.$api
          .bindSensor({
            gatewayNo: wgID.trim(),
            sensorIds: sensorIds ? sensorIds : [...this.alreadyBindIds, rtuID.trim()],
          })
          .then((res) => {
            if (res.errcode === 0) {
              this.$toast({
                type: 'success',
                message: this.$t(sensorIds ? '解绑成功' : '绑定成功'),
              })

              this.getCgqList()
              this.resetState()
            } else {
              this.$toast({
                type: 'fail',
                message: res.errmsg || this.$t('绑定失败'),
              })
            }
          })
          .catch((err) => {
            this.$toast({
              type: 'error',
              message: err.errmsg || this.$t('绑定失败'),
            })
          })
      } catch (error) {
        console.error(error)
      }

      setTimeout(() => {
        this.$toast.clear()
      }, 1500);

    },
  },
}
</script>

<style>
body {
  width: 100%;
  height: 100%;
  /* background: url(../../../assets/images/lobg.jpg) top no-repeat; */
  background-size: 100% 100%;
}
</style>

<style lang="scss" scoped>
::v-deep .van-field__control:disabled {
  -webkit-text-fill-color: #323233 !important;
}

::v-deep .van-field--disabled .van-field__label {
  color: #646566 !important;
}

.rform {
  width: 6rem;
  margin: 0 auto;
  padding: 0 0.2rem;
  padding-top: 0.77rem;
  margin-top: 20px;

  ::v-deep .van-cell {
    padding: 0;
    // box-shadow: 0 0.05rem 0.1rem #827d88;
    border: 0.4px solid #bdbdbd;
    border-radius: 6.18182px;
    margin-bottom: 0.2rem;

    .van-field__control {
      padding: 16px 0;
    }

    .van-field__label {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .van-button--default {
    border: none !important;
  }

  .scan {
    display: flex;

    .scan_code {
      align-items: center;
      justify-content: center;
      img {
        width: 0.4rem;
        height: 0.4rem;
      }
    }
  }
}

// 注册
.submit {
  width: 6rem;
  height: 48px;
  line-height: 48px;
  background: #27b0f6;
  text-align: center;
  color: #fff;
  margin: 0rem auto 0;
  font-size: 16px;
  box-shadow: 0 0.05rem 0.1rem #827d88;
  border-radius: 0;
  border: 0 !important;
}

.btns {
  display: flex;
  justify-content: space-evenly;
  margin-top: 40px;

  .btn {
    width: 108.8px;
    height: 49.87px;
    color: #ffffff;
  }

  .cancelBtn {
    background: #dadada;
    box-shadow: 0px 2px 7px rgba(0, 0, 0, 0.1);
    border-radius: 6.18182px;
  }

  .confirmBtn {
    background: #3566dc;
    box-shadow: 0px 2px 7px rgba(0, 0, 0, 0.1);
    border-radius: 6.18182px;
    margin: 0 8px;
  }
}

.port-tip {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  font-size: 12px;

  .yellow {
    color: #e2750f;
  }
  .blue {
    display: flex;
    align-items: center;
    color: #3566dc;
  }
  .red {
    color: #f22d13;
  }
  .green {
    color: rgb(19, 213, 19);
  }
  .black {
    color: #000000;
  }
}
</style>
